import React, { memo, useRef } from "react";
import RosterCell from "./RosterCell";

const DAY_KEYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

function RosterRow({
  user,
  dates,
  days,
  shiftTemplates,
  orgWorkingDays,
  draftCells,
  isDraftMode,
  focusedDate,
  selectedDates,
  onCellMouseDown,
  onCellMouseEnter,
  onCellClick,
  onCellKeyDown,
  todayStr,
  cellRefs,
}) {
  const initials = `${user.firstName?.[0] || ""}${user.lastName?.[0] || ""}`.toUpperCase();

  return (
    <tr className="roster-row">
      <td className="roster-user-col">
        <div className="roster-user-cell">
          <div className="roster-user-avatar">{initials}</div>
          <div className="roster-user-info">
            <span className="roster-user-name">
              {user.firstName} {user.lastName}
            </span>
            {user.role && <span className="roster-user-role">{user.role}</span>}
          </div>
        </div>
      </td>

      {dates.map((dateStr) => {
        const refKey = `${user.userId}:${dateStr}`;
        const d = new Date(dateStr);
        const isWeekend = !orgWorkingDays?.includes(DAY_KEYS[d.getDay()]);

        return (
          <RosterCell
            key={dateStr}
            ref={(el) => {
              if (el) cellRefs.current.set(refKey, el);
              else cellRefs.current.delete(refKey);
            }}
            userId={user.userId}
            dateStr={dateStr}
            dayData={days?.[dateStr]}
            draftCell={draftCells?.[dateStr] || null}
            shiftTemplates={shiftTemplates}
            isSelected={selectedDates?.has(dateStr)}
            isFocused={focusedDate === dateStr}
            isDraftMode={isDraftMode}
            isWeekend={isWeekend}
            isToday={dateStr === todayStr}
            onMouseDown={onCellMouseDown}
            onMouseEnter={onCellMouseEnter}
            onClick={onCellClick}
            onKeyDown={onCellKeyDown}
          />
        );
      })}
    </tr>
  );
}

export default memo(RosterRow);
